/* eslint-disable no-unused-vars, max-len */
import { ArrowRightIcon } from "@heroicons/react/24/solid";
import Helmet from "react-helmet";
import { NavLink } from "react-router-dom";
import { useMemo } from "react";

import AssessmentData from "../../liaStatements/statements_en.json";
import Loader from "../../components/Loader";
import { getProfileProgress } from "../../helpers/respondents";
import { pageContent } from "../services/eqqo.page.content";
import { useQuery } from "react-query";
import { useUser } from "../UserContext";

const Help = () => {
	const { eqqoOptions, respondent } = useUser();
	const {
		data: faqContent,
		isLoading
	} = pageContent( eqqoOptions?.faq, useQuery, { enabled: !!eqqoOptions?.faq });

	const progress = useMemo(() => ({ ...getProfileProgress(respondent?.weqProfile?.profileResponses || [], AssessmentData.scenarios) }), [respondent]);
	const profileCompleted = useMemo(() => respondent?.profilecomplete || respondent?.weqProfile?.profilestatus === "completed" || respondent?.weqProfile?.profilestatus === "review", [respondent]);

	return isLoading
		? <Loader />
		: (
			<div>
				<Helmet>
					<title>{"EQQO Help"}</title>
				</Helmet>
				<div className="help-content" dangerouslySetInnerHTML={{ __html: faqContent?.content?.rendered }} />
				{ respondent?.weqProfile?.readInstructions && !profileCompleted ? (
					<NavLink className="btn btn-gradient w-100 mt-4 w-100" to={`/profile/assessment/${progress.nextScenario || 1}`}>
						Continue Assessment <ArrowRightIcon height={24} width={24} />
					</NavLink>
				) : null }
			</div>
		);
};

export default Help;
